import { render, staticRenderFns } from "./ShipmentZonesComponent.vue?vue&type=template&id=67e85f5a"
import script from "./ShipmentZonesComponent.vue?vue&type=script&lang=js"
export * from "./ShipmentZonesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports